// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media screen and (max-width:1023px){div.bucket[data-v-5d8cf04b]{padding:12px 0}}", ""]);
// Exports
module.exports = exports;
